<div class="sfl-item d-flex w-100 align-items-center pl-3 pr-2 {{item.isgroup ? 'group' : ''}} {{opened ? 'opened' : ''}} {{item.copyValueFrom?.length ? 'linked connected' : ''}} {{prefix}}-item" style="--i: {{item.level ? (item.level - 1) : 0}}" (click)="item.isgroup ? toggle() : false;" id="{{prefix}}-{{item.fullKey}}">
    <i *ngIf="item.isgroup && !opened" class="fas sfl-item-type-icon no-bg fa-angle-down mr-2"></i>
    <i *ngIf="item.isgroup && opened" class="fas sfl-item-type-icon no-bg fa-angle-up mr-2"></i>
    <i *ngIf="(item.level ? (item.level > 1 || !item.isgroup) : true)" class="{{item.icon || item.typeclass}} sfl-item-type-icon flex-shrink-0 mr-2"></i>
    <span class="sfl-item-title flex-grow-1">{{item.title || item.name || item.key}}</span>
</div>

<ng-container *ngIf="item.items && item.items.length > 0">
    <div class="sfl-item-container bg-white">
        <ng-container *ngFor="let it of item.items">
            <generic-sfl-item *ngIf="!it.isgroup || (it.isgroup && it.items.length > 0)" [prefix]="prefix" [item]="it" (updated)="update()" (isReady)="ready()"></generic-sfl-item>
        </ng-container>
    </div>
</ng-container>
